// extracted by mini-css-extract-plugin
export default {"headerBlock":"Header_headerBlock__lus-J","header":"Header_header__c5nVa"};